var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: _vm.itemClass,
      attrs: { href: _vm.redirect_uri || "#" },
      on: {
        click: function($event) {
          !_vm.isClickable && $event.preventDefault()
        }
      }
    },
    [
      _c("CompassIcon", { attrs: { icon: _vm.icon } }),
      _vm._v(" "),
      _c("span", [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]),
      _vm._v(" "),
      !_vm.available
        ? _c("CompassFlag", {
            attrs: { label: _vm.$t.__("common.labels.soon"), size: "small" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }